(function() {
    'use strict';

    angular.module('app').factory('VehicleCollection', ['$http', '$q', 'Vehicle', VehicleCollectionFactory]);

    function VehicleCollectionFactory($http, $q, Vehicle) {
        function VehicleCollection() {
            this.collection = [];
            this.selected = false;
            this.loaded = false;
        }

        function intersectRect(r1, r2) {
            return !(r2.left >= r1.right || r2.right <= r1.left || r2.top >= r1.bottom || r2.bottom <= r1.top);
        }

        VehicleCollection.prototype.create = function(list) {
            for (var i in list) {
                var item = list[i];

                var vehicle = new Vehicle(item);
                vehicle.key = i;

                this.collection.push(vehicle);
            }
            this.loaded = true;
        };

        VehicleCollection.prototype.update = function(list) {
            for (var i in list) {
                var item = list[i];
                var vehicle = this.get(item.objectId);

                if (vehicle) {
                    vehicle.update(item);
                }
            }
        };

        VehicleCollection.prototype.cluster = function(vehicle) {
            if (vehicle.cluster !== null) {
                return;
            }

            this.collection.forEach(function(o) {
                if (o.cluster === null && o.id !== vehicle.id) {
                    if (intersectRect(vehicle.bounds, o.bounds)) {
                        vehicle.cluster = vehicle.id;
                        o.cluster = vehicle.id;
                    }
                }
            });
        };

        VehicleCollection.prototype.get = function(id) {
            var vehicle = this.collection.filter(function(o) {
                return o.id === id;
            });
            return vehicle.length ? vehicle[0] : false;
        };

        VehicleCollection.prototype.list = function() {
            return this.collection;
        };

        VehicleCollection.prototype.isSelected = function(vehicle) {
            if (vehicle === void 0) {
                return this.selected !== false;
            }
            return this.selected === vehicle;
        };

        VehicleCollection.prototype.select = function(vehicle) {
            return (this.selected = vehicle);
        };

        VehicleCollection.prototype.unselect = function() {
            return (this.selected = false);
        };

        VehicleCollection.prototype.getSelected = function() {
            return this.selected;
        };

        VehicleCollection.prototype.getExtendedData = function() {
            var self = this;
            var payload = {};

            self.collection.forEach(function(vehicle) {
                if (vehicle.extended.need && vehicle.extended.show) {
                    payload[vehicle.id] = {
                        ObjectId: vehicle.id,
                    };
                }
            });

            if (angular.equals({}, payload)) {
                return $q.resolve([]);
            }

            return $http.post('/api/object/extendedData', payload, { displayButterbar: false }).then(function(response) {
                var data = response.data.data;
                self.collection.forEach(function(vehicle) {
                    if (data[vehicle.id] !== void 0) {
                        vehicle.extend(data[vehicle.id]);
                        vehicle.extended.need = false;
                    }
                });
            });
        };

        VehicleCollection.prototype.groupNearestObjects = function(zoom, bars) {
            /*
             * Define how registry numbers should align on the map in mobile view
             * If there is more objects then they will split into more columns one by one
             */
            var GROUPED_OBJECTS_MAX_MOBILE_COUNT = 20;

            var constantObjectNumberSize = {
                width: 90,
                height: 30,
            };
            var groups = {};

            /*
             * handle google map cluster way grouping
             */

            var collection = this.list();

            if (zoom <= 13) {
                for (var i in collection) {
                    var vehicle = collection[i];

                    if (!vehicle.location().x && !vehicle.location().y) {
                        continue;
                    }

                    if (!vehicle.cluster) {
                        groups[vehicle.id] = [];
                        groups[vehicle.id].push({
                            id: vehicle.id,
                            group: vehicle.id,
                            offset: 0,
                            column: 0,
                            location: angular.copy(vehicle.location()),
                        });
                        continue;
                    }

                    if (groups[vehicle.cluster] === void 0) {
                        groups[vehicle.cluster] = [];
                    }

                    var length = groups[vehicle.cluster].length;
                    var column = 0;
                    var offset = length;

                    /*
                     * Group vehicles in seperate columns
                     */
                    if (bars) {
                        column = Math.floor(length / GROUPED_OBJECTS_MAX_MOBILE_COUNT);
                        offset = length % GROUPED_OBJECTS_MAX_MOBILE_COUNT;
                    }

                    var loc = angular.copy(
                        groups[vehicle.cluster].length > 0 ? groups[vehicle.cluster][0].location : vehicle.location()
                    );

                    groups[vehicle.cluster].push({
                        id: vehicle.id,
                        group: vehicle.cluster,
                        offset: offset,
                        column: column,
                        location: loc,
                    });
                }
                return { groups: groups, plates: constantObjectNumberSize };
            }

            /*
             * handle normal seperate objects way grouping
             */

            var current = 0;

            for (var i in collection) {
                var vehicle = angular.copy(collection[i]);

                if (i < 1) {
                    groups[current] = [];
                    groups[current].push({
                        id: vehicle.id,
                        group: current,
                        offset: 0,
                        column: 0,
                        location: angular.copy(vehicle.location()),
                        left: vehicle.bounds.left,
                        top: vehicle.bounds.top,
                    });
                    current++;
                    continue;
                }
                var single = true;

                for (var k = 0; k < groups.length; k++) {
                    if (!single) continue;
                    var list = groups[k];

                    for (var j = 0; j < list.length; j++) {
                        if (!single) continue;
                        var record = list[j];

                        var x = Math.abs(vehicle.bounds.left - record.left);
                        var y = Math.abs(vehicle.bounds.top - record.top);

                        if (x < constantObjectNumberSize.width && y < constantObjectNumberSize.height) {
                            var length = list.length;
                            var first = list[0];

                            var column = 0;
                            var offset = length;

                            /*
                             * Group vehicles in seperate columns
                             */
                            if (bars) {
                                column = Math.floor(length / GROUPED_OBJECTS_MAX_MOBILE_COUNT);
                                offset = length % GROUPED_OBJECTS_MAX_MOBILE_COUNT;
                            }

                            var loc = angular.copy(first.location);

                            groups[k].push({
                                id: vehicle.id,
                                group: first.group,
                                offset: offset,
                                column: column,
                                location: loc,
                                left: vehicle.bounds.left,
                                top: vehicle.bounds.top,
                            });
                            single = false;
                        }
                    }
                }

                if (single) {
                    groups[current] = [];
                    groups[current].push({
                        id: vehicle.id,
                        group: current,
                        offset: 0,
                        column: 0,
                        location: angular.copy(vehicle.location()),
                        left: vehicle.bounds.left,
                        top: vehicle.bounds.top,
                    });
                    current++;
                }
            }
            return { groups: groups, plates: constantObjectNumberSize };
        };

        return VehicleCollection;
    }
})();
